/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import Chips from "../../../../components/_utils/CommonButtons/Chips";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import PrimaryRightIconFill from "../../../../components/_utils/CommonButtons/PrimaryRightIconFill";
import SecondaryRightIconSmallButton from "../../../../components/_utils/CommonButtons/SecondaryRightIconSmallButton/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import SmallPopupWithBulletPoint from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import ConsolidatedBankPopup from "../../../../components/Accounts/ConsolidatedBankPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import {
  remitterAccountApprove,
  remitterAccountArchive,
  remitterAccountDetailsById,
  remitterAccountReject,
  remitterAccountUnarchive,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount.js";
import accountNameStandardised from "../../../../utils/accountNamestandardised.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  RejectReasonLength,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import TEXT from "../../../../utils/globalText";

const RemitterAccountDetails = ({
  popup,
  rem_account_id,
  closeBeneAccountDetailModal,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bankBarRef = useRef(null);
  const liveBarRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const [mainData, setMaindata] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [clickedBtn, setClickedBtn] = useState(null);
  const [rejectAccount, setRejectAccount] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [declineReason, setDeclineReason] = useState("");
  const [animationClass, setAnimationClass] = useState("");
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectCardBank, setselectCardBank] = useState(false);
  const [selectCardLive, setselectCardLive] = useState(false);
  const [archiveAccount, setArchiveAccount] = useState(false);
  const [consolidatedBank, setConsolidatedBank] = useState([]);
  const [consolidatedLive, setConsolidatedLive] = useState([]);
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [unArchiveAccount, setUnArchiveAccount] = useState(false);
  const [ViewAccountDetails, setViewAccountDetails] = useState([]);
  const [selectedLiveCardId, setSelectedLiveCardId] = useState(null);
  const [viewStatementOpenPop, setViewstatementOpenPop] = useState(false);
  const [index, setIndex] = useState(GlobalConfiguration.lengthCheckZero);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [bankBarHeight, setBankBarHeight] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [liveBarHeight, setLiveBarHeight] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const {
    remitterAccountDetailsData,
    remitterAccountDetailsLoading,
    remitterAccountRejectLoading,
  } = useSelector((state) => state.remitterAccount);

  const isArchivedAccount =
    remitterAccountDetailsData?.approval_status?.toLowerCase()?.trim() ===
    "archived";

  const hasEditPermission =
    services?.includes("REUAccount") && !isArchivedAccount;

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const updateAllAccounts = (updatedAccounts) => {
    setViewAccountDetails(updatedAccounts);
  };

  const handleClosePopup = () => {
    setshowPopupReject(false);
    setDeclineReason("");
  };

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setshowPopupReject(true);
  };

  const handleFetch = async () => {
    setLoader(true);

    try {
      let data = await dispatch(
        remitterAccountDetailsById({ id: rem_account_id || id }),
      );
      setMaindata(data?.payload?.remitter_accounts[0]);
      setLabelDetails(data?.payload?.remitter_accounts[0]?.labels);
    } catch (error) {
      CommonToast({
        text: error?.message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setLoader(false);
    }
  };

  const handleInputChange = (event) => {
    let value = event?.target?.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    value = value.replace(/^\s+/, "");

    value = value.replace(/\s{2,}/g, " ");

    value = value.slice(0, 150);

    setDeclineReason(value);
  };

  const handleCloseModal = () => {
    setUnArchiveAccount(false);
    setArchiveAccount(false);
  };

  const handleDeclined = async (id, AccountIdData) => {
    setShowLoader(true);
    setRejectAccount(true);
    setshowPopupReject(false);
    setClickedBtn("reject");
    UniversalRefreshToast("accountsRefresh");

    if (
      !remitterAccountRejectLoading ||
      remitterAccountRejectLoading === null
    ) {
      const data = await dispatch(
        remitterAccountReject({
          id: id || rem_account_id,
          rejection_reason: AccountIdData,
        }),
      );
      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "REAAccount",
          },
        });
        return;
      }

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false || data?.payload === undefined) {
        let error_msg = "";
        let error_list = null;
        if (data?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (data?.payload?.errors?.tds_account) {
          if (
            data?.payload?.errors?.tds_account?.length >
            GlobalConfiguration?.lengthCheckOne
          ) {
            error_list = data?.payload?.errors?.tds_account;
            error_msg = data?.payload?.errors?.tds_account[0];
          } else {
            error_msg = data?.payload?.errors?.tds_account;
            CommonToast({
              text: error_msg[0],
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }
        } else if (data?.payload?.status === false) {
          error_msg = data?.payload?.errors?.category?.[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = data?.payload?.errors?.bank_account_number[0];
        }

        if (error_msg === "remitter account already rejected") {
          const newData = await dispatch(
            remitterAccountDetailsById({ id: rem_account_id || id }),
          );
          const updatedRemAccount = {
            ...newData?.payload?.tds?.[0],
            error_msg,
            error: data?.payload?.status === false ? true : false,
          };

          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                ...(updatedRemAccount || {}),
              };
            }
            return item;
          });
          setShowLoader(false);
          updateAllAccounts(updatedData);
        } else {
          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                error_msg,
                error: data?.payload?.status === false ? true : false,
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
          setShowLoader(false);
        }
        setShowLoader(false);
        setDeclineReason("");
        handleClosePopup();
        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            setTimeout(() => {
              CommonToast({
                text: err,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration?.intervalSmall);
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
        setRejectAccount(false);
      } else {
        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.tds_account?.[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.tds_account?.[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === false && data?.payload?.status === false
                  ? true
                  : false,
              message:
                item.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.tds_account[0]
                  : "",
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);

        setDeclineReason("");
        handleClosePopup();

        CommonToast({
          text: `Account rejected successfully.`,
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        if (popup) {
          setTimeout(() => {
            closeBeneAccountDetailModal();
            window.location.reload();
          }, IntervalConfiguration.intervalExtraSmall);
        }
        setShowLoader(false);
        await dispatch(
          remitterAccountDetailsById({
            id: rem_account_id || id,
          }),
        );
        setRejectAccount(false);
      }
    }
  };

  const handleApprovalDetails = async (id) => {
    setShowLoader(true);

    setClickedBtn("approve");
    setShowLoader(true);

    let response;
    UniversalRefreshToast("approvalaccountsRefresh");

    if (popup) {
      response = await dispatch(
        remitterAccountApprove({
          id: rem_account_id,
        }),
      );
    } else {
      response = await dispatch(remitterAccountApprove({ id }));
    }

    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "REAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.tds_account?.[0]) {
        error_msg = response.payload.errors.tds_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "remitter account already approved") {
        const updatedData = remitterAccountDetailsData?.map((item) => {
          if (item.id === (popup ? rem_account_id : id)) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }
          return item;
        });
        setViewAccountDetails(updatedData);

        response = await dispatch(
          remitterAccountDetailsById({
            id: rem_account_id || id,
          }),
        );
        setShowLoader(false);
      } else {
        const updatedData = [remitterAccountDetailsData]?.map((item) => {
          if (item.id === (popup ? rem_account_id : id)) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "pending" : "",
              error_msg,
            };
          }
          return item;
        });

        setViewAccountDetails(updatedData);
      }
      CommonToast({
        text: `${error_msg}`,
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
    } else {
      const updatedData = [remitterAccountDetailsData]?.map((item) => {
        if (item.id === (popup ? rem_account_id : id)) {
          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? "approved" : "pending",
          };
        }
        return item;
      });
      setViewAccountDetails(updatedData);

      response = await dispatch(
        remitterAccountDetailsById({
          id: rem_account_id || id,
        }),
      );
      const successMessage = "Account approved successfully.";
      CommonToast({
        text: `${successMessage}`,
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        buttonNeeded: false,
      });
      if (popup) {
        setTimeout(() => {
          closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }
      setShowLoader(false);
    }
  };

  const handleUnArchive = () => {
    setUnArchiveAccount(true);
    if (remitterAccountDetailsData?.archived === "N") {
      setUnArchiveAccount(false);
    } else {
      setUnArchiveAccount(true);
    }
  };

  const handleArchive = () => {
    if (remitterAccountDetailsData?.archived === "N") {
      setArchiveAccount(true);
    } else {
      setArchiveAccount(false);
    }
  };

  const handleArchiveButton = async () => {
    let thunkAction = remitterAccountArchive;

    UniversalRefreshToast("archive");
    const archived_response = await dispatch(thunkAction(id));
    if (
      archived_response.type !== "achivedTaxAccountDetail/rejected" ||
      archived_response.payload === "Remitter account already archived."
    ) {
      const data = await dispatch(remitterAccountDetailsById({ id }));
      if (data?.payload?.status === true) {
        CommonToast({
          text: `Account archived successfully.`,
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
    }
    handleCloseModal();
    setArchiveAccount(false);
  };

  const handleUnArchiveButton = async () => {
    let thunkAction = remitterAccountUnarchive;

    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(thunkAction(id));
    if (
      unarchived_response.type !== "unachivedTaxAccountDetail/rejected" ||
      unarchived_response.payload === "Remitter account already pending"
    ) {
      const data = await dispatch(remitterAccountDetailsById({ id }));
      if (data?.payload?.status === true) {
        CommonToast({
          text: `Account unarchived successfully.`,
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
    }
    handleCloseModal();
  };

  const handleCardClick = (transactions) => {
    if (selectCardBank) {
      const isAlreadySelected = consolidatedBank?.includes(transactions.txn_id);

      if (isAlreadySelected) {
        setConsolidatedBank((prev) =>
          prev.filter((id) => id !== transactions.txn_id),
        );
      } else {
        setConsolidatedBank((prev) => [...prev, transactions.txn_id]);
      }
    } else {
      setSelectedCardId((prev) =>
        prev === transactions.txn_id ? null : transactions.txn_id,
      );
    }
  };

  const handleLiveCardClick = (transactions) => {
    if (selectCardLive) {
      const isAlreadySelected = consolidatedLive?.includes(transactions.txn_id);

      if (isAlreadySelected) {
        setConsolidatedLive((prev) =>
          prev.filter((id) => id !== transactions.txn_id),
        );
      } else {
        setConsolidatedLive((prev) => [...prev, transactions.txn_id]);
      }
    } else {
      setSelectedLiveCardId((prev) =>
        prev === transactions.txn_id ? null : transactions.txn_id,
      );
    }
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    handleFetch();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    const observers = [];

    if (bankBarRef.current) {
      const ro = new ResizeObserver(([entry]) => {
        setBankBarHeight(entry.contentRect.height + 20);
      });
      ro.observe(bankBarRef.current);
      observers.push(ro);
    }

    if (liveBarRef.current) {
      const ro = new ResizeObserver(([entry]) => {
        setLiveBarHeight(entry.contentRect.height + 20);
      });
      ro.observe(liveBarRef.current);
      observers.push(ro);
    }

    return () => observers.forEach((ro) => ro.disconnect());
  }, [index]);

  return (
    <>
      {viewStatementOpenPop && (
        <ConsolidatedBankPopup
          type={"remitterBankStatement"}
          setViewstatementOpenPop={setViewstatementOpenPop}
          ownerDetailId={"55180961-99b3-4d94-9ed7-3be230dd7cb4"}
        />
      )}
      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Before rejecting the account, any matched transactions (if present) will need to be unmatched in the following steps."
            noteColor="text-secondary"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              handleClosePopup();
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              handleDeclined(id, declineReason);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      {archiveAccount && (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
            <SmallPopupWithBulletPoint
              headerTitle={"Confirm archiving this account?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              bulletPoints={[
                "This account will become inactive.",
                "Matching and unmatching actions will be restricted for archived accounts.",
              ]}
              isTextInputField={false}
              btnOneText="Cancel"
              btnOneHandleFunction={() => setArchiveAccount(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText={"Archive"}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
              btnTwoHandleFunction={() => {
                handleArchiveButton();
              }}
            />
          </div>
        </>
      )}
      {unArchiveAccount && (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
            <SmallPopupWithBulletPoint
              headerTitle={"Confirm unarchiving this account?"}
              subtext="This account will become active."
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              isTextInputField={false}
              btnOneText="Cancel"
              btnOneHandleFunction={() => setUnArchiveAccount(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText={"Unarchive"}
              btnTwoEnabledBgColor="var(--positive-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
              btnTwoHandleFunction={() => {
                handleUnArchiveButton();
              }}
            />
          </div>
        </>
      )}
      <div className="h-screen w-full flex flex-col bg-primary-bg overflow-hidde">
        {remitterAccountDetailsLoading ? (
          <div
            className={`absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center`}
          >
            <Loader />
          </div>
        ) : (
          <>
            {rejectAccount && (
              <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"></div>
            )}
            <div
              className={`min-h-mobile-navbar-height ${popup ? "hidden" : "block"} Qsmd:min-h-navbar-breadcrumb-height bg-primary-nav w-full`}
            >
              <div className="fixed top-top-base  left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
                <TopNavComponent
                  topNavHeader={"Remitter"}
                  isFormattingNotRequired
                  topNavSubText="Account details"
                  handleBack={(e) => {
                    navigate(GlobalConfiguration.navigate_back);
                  }}
                />
              </div>
            </div>
            <div className="overflow-y-auto">
              <div className="bg-primary-nav w-full">
                <div className="w-full mx-auto my-margin-base max-w-tab-width-normal h-fit flex flex-col overflow-hidden Qlg:px-padding-base">
                  <div>
                    <div className="flex justify-between w-full">
                      <div className="pt-padding-lg ml-margin-sm pb-padding-md px-padding-md Qsmd:px-padding-base Qsmd:py-padding-md flex items-center">
                        <TitleSubtitlePair
                          title={
                            remitterAccountDetailsData
                              ? accountNameStandardised(
                                  remitterAccountDetailsData?.name,
                                )
                              : "NA"
                          }
                          titleColor="text-primary"
                          subtitle={"Account name"}
                          alignRight={false}
                          hoverOption="white"
                          isBold={false}
                          variant="md"
                        />
                      </div>

                      <div className="hidden Qsmd:flex">
                        <div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                In bank <br /> statement
                              </>
                            }
                            handleFunction={() => {
                              if (popup) {
                                actionRestricted();
                              } else {
                                CommonToast({
                                  text: "Feature coming soon",
                                  icon: ICONS?.INFO,
                                  variant: "var(--coming-soon)",
                                  buttonNeeded: false,
                                });
                              }
                            }}
                            isDisabled={popup || isArchivedAccount}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.MATCHED_WITH_CIRCLE}
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </div>
                        <div className="border-r border-primary-bg"></div>
                        <div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                In live <br /> statement
                              </>
                            }
                            handleFunction={() => {
                              if (popup) {
                                actionRestricted();
                              } else {
                                CommonToast({
                                  text: "Feature coming soon",
                                  icon: ICONS?.INFO,
                                  variant: "var(--coming-soon)",
                                  buttonNeeded: false,
                                });
                              }
                            }}
                            isDisabled={popup || isArchivedAccount}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.MATCHED_WITH_CIRCLE}
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </div>
                        <div className="border-r border-primary-bg"></div>
                        <div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                Edit <br /> account
                              </>
                            }
                            handleFunction={() => {
                              if (popup) {
                                actionRestricted();
                              } else {
                                CommonToast({
                                  text: "Feature coming soon",
                                  icon: ICONS?.INFO,
                                  variant: "var(--coming-soon)",
                                  buttonNeeded: false,
                                });
                              }
                            }}
                            isDisabled={popup || !hasEditPermission}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                            hoverOption="white"
                            // fullWidthRequired={true}
                          />
                        </div>
                        <div className="border-r border-primary-bg"></div>
                        <div>
                          <TopNavSmallButton
                            btnText={
                              remitterAccountDetailsData?.approval_status ===
                              "archived" ? (
                                <>
                                  Unarchive <br /> account
                                </>
                              ) : (
                                <>
                                  Archive <br /> account
                                </>
                              )
                            }
                            icon={
                              remitterAccountDetailsData?.approval_status ===
                              "archived"
                                ? ICONS?.UNARCHIVE
                                : ICONS?.ARCHIVE
                            }
                            isDisabled={
                              popup ||
                              !services?.find(
                                (service) =>
                                  service === "REAAccountArchive" ||
                                  service === "Admin",
                              )
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            handleFunction={() => {
                              const hasPermission = services?.some(
                                (service) =>
                                  service === "REAAccountArchive" ||
                                  service === "Admin",
                              );

                              if (popup) {
                                actionRestricted();
                                return;
                              }

                              if (hasPermission) {
                                handleUnArchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "REAAccountArchive",
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-t border-primary-bg"></div>
                  <div className="h-fit px-padding-base relative">
                    <div className="flex flex-col Qsmd:flex-row Qsmd:fle">
                      <div className="flex flex-1 px-padding-md ml-margin-sm Qsmd:px-padding-base py-padding-md pb-padding-md Qmd:pb-padding-md">
                        <TitleSubtitlePair
                          title={
                            remitterAccountDetailsData
                              ? remitterAccountDetailsData?.approval_status
                                  ?.toLowerCase()
                                  ?.replace(/\b\w/g, (char) =>
                                    char.toUpperCase(),
                                  )
                              : "NA"
                          }
                          titleColor={
                            remitterAccountDetailsData?.approval_status ===
                            "approved"
                              ? "awaiting"
                              : remitterAccountDetailsData?.approval_status ===
                                  "pending"
                                ? "pending"
                                : remitterAccountDetailsData?.approval_status ===
                                    "archived"
                                  ? "abandoned"
                                  : remitterAccountDetailsData?.approval_status ===
                                      "rejected"
                                    ? "failed"
                                    : "abandoned"
                          }
                          subtitle={"Status"}
                          alignRight={false}
                          hoverOption="white"
                          isBold={true}
                          variant="md"
                        />
                      </div>

                      <div
                        className={`${remitterAccountDetailsData?.approval_status === "pending" ? "block" : "hidden"} h-positive-negative-btn-height `}
                      >
                        {showLoader ? (
                          <>
                            <div className="Qsmd:w-max-button-width-for-approval-animation w-full flex">
                              <div
                                className={`w-width-full flex justify-center items-center py-padding-lg ${
                                  clickedBtn === "reject"
                                    ? "bg-negative-act"
                                    : "bg-positive-act"
                                }`}
                              >
                                <Loader
                                  height="var(--icon-lg)"
                                  width="var(--icon-lg)"
                                />
                              </div>
                            </div>
                          </>
                        ) : false ? (
                          <div
                            // key={account.id}
                            className={`pay-bene-box2 flex justify-end ${
                              false
                                ? "bg-Button-green hover:opacity-dark-opacity"
                                : false
                                  ? "bg-Button-green"
                                  : ""
                            }`}
                          >
                            <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                              <div className="flex place-items-center">
                                <img
                                  src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                  alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                />
                              </div>
                              <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                <span className="font-semibold font-sans text-xs text-text-primary">
                                  Failed to take action
                                </span>

                                <span className="font-sans text-font-xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                  Failed to take action
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : remitterAccountDetailsData?.approval_status ===
                          "pending" ? (
                          <>
                            <div
                              // key={account.id}
                              className={`pay-bene-box2 flex justify-end w-full ${
                                remitterAccountDetailsData?.approval_status ===
                                  "approved" &&
                                services?.find(
                                  (service) =>
                                    service === "REAAccount" ||
                                    service === "Admin",
                                ) !== undefined
                                  ? "bg-Button-green hover:opacity-dark-opacity"
                                  : remitterAccountDetailsData?.approval_status ===
                                      "approved"
                                    ? "bg-Button-green"
                                    : ""
                              } `}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Reject <br /> account
                                  </>
                                }
                                handleFunction={() => {
                                  if (
                                    services?.find(
                                      (service) =>
                                        service === "REAAccount" ||
                                        service === "Admin",
                                    ) !== undefined
                                  ) {
                                    handleDeclinedDetials(id || rem_account_id);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "REAAccount",
                                      },
                                    });
                                  }
                                }}
                                icon={ICONS?.REJECT_ICON_RED}
                                enabledBgColor={"var(--negative-act)"}
                                isDisabled={
                                  !services?.find(
                                    (service) =>
                                      service === "REAAccount" ||
                                      service === "Admin",
                                  )
                                }
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="black"
                                fullWidthRequired={isMobile}
                              />

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Approve <br /> account
                                  </>
                                }
                                isDisabled={
                                  !services?.find(
                                    (service) =>
                                      service === "REAAccount" ||
                                      service === "Admin",
                                  )
                                }
                                handleFunction={() => {
                                  if (
                                    services?.find(
                                      (service) =>
                                        service === "REAAccount" ||
                                        service === "Admin",
                                    ) !== undefined
                                  ) {
                                    handleApprovalDetails(
                                      remitterAccountDetailsData?.id,
                                    );
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "REAAccount",
                                      },
                                    });
                                  }
                                }}
                                // handleFunction={() => {
                                //   setClickedBtn("approve");
                                //   handleApprovalDetails();
                                // }}
                                icon={ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK}
                                enabledBgColor={"var(--positive-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="black"
                                fullWidthRequired={isMobile}
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-primary-card mt-margin-sm flex flex-col Qsmd:hidden">
                <div className="bg-primary-card w-width-full px-padding-md py-padding-sm">
                  <p
                    style={{
                      fontWeight: "var(--font-semibold)",
                      letterSpacing: "var(--letter-space)",
                    }}
                    className="text-text-primary text-font-md font-normal"
                  >
                    Quick Actions
                  </p>
                </div>
                <div className="flex w-full">
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        <>
                          In bank <br /> statement
                        </>
                      }
                      handleFunction={() => {
                        if (popup) {
                          actionRestricted();
                        } else {
                          CommonToast({
                            text: "Feature coming soon",
                            icon: ICONS?.INFO,
                            variant: "var(--coming-soon)",
                            buttonNeeded: false,
                          });
                        }
                      }}
                      isDisabled={popup || isArchivedAccount}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      icon={ICONS?.MATCHED_WITH_CIRCLE}
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="border-r border-primary-bg"></div>
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        <>
                          In live <br /> statement
                        </>
                      }
                      handleFunction={() => {
                        if (popup) {
                          actionRestricted();
                        } else {
                          CommonToast({
                            text: "Feature coming soon",
                            icon: ICONS?.INFO,
                            variant: "var(--coming-soon)",
                            buttonNeeded: false,
                          });
                        }
                      }}
                      isDisabled={popup || isArchivedAccount}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      icon={ICONS?.MATCHED_WITH_CIRCLE}
                      fullWidthRequired={true}
                    />
                  </div>
                </div>
                <div className="border-b border-solid border-primary-bg"></div>
                <div className="flex">
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Edit <br /> account
                        </>
                      }
                      handleFunction={() => {
                        if (popup) {
                          actionRestricted();
                        } else {
                          CommonToast({
                            text: "Feature coming soon",
                            icon: ICONS?.INFO,
                            variant: "var(--coming-soon)",
                            buttonNeeded: false,
                          });
                        }
                      }}
                      isDisabled={popup || !hasEditPermission}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                      hoverOption="white"
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="border-r border-primary-bg"></div>
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        remitterAccountDetailsData?.approval_status ===
                        "archived" ? (
                          <>
                            Unarchive <br /> account
                          </>
                        ) : (
                          <>
                            Archive <br /> account
                          </>
                        )
                      }
                      isDisabled={
                        popup ||
                        !services?.find(
                          (service) =>
                            service === "REAAccountArchive" ||
                            service === "Admin",
                        )
                      }
                      handleFunction={() => {
                        const hasPermission = services?.some(
                          (service) =>
                            service === "REAAccountArchive" ||
                            service === "Admin",
                        );

                        if (popup) {
                          actionRestricted();
                          return;
                        }

                        if (hasPermission) {
                          handleUnArchive();
                          handleArchive();
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "REAAccountArchive",
                            },
                          });
                        }
                      }}
                      icon={
                        remitterAccountDetailsData?.approval_status ===
                        "archived"
                          ? ICONS?.UNARCHIVE
                          : ICONS?.ARCHIVE
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      fullWidthRequired={true}
                    />
                  </div>
                </div>
              </div>
              {false ? (
                <></>
              ) : (
                <div className="bg-primary-bg relative w-full overflow-x-hidden flex flex-col">
                  {(index === GlobalConfiguration.lengthCheckTwo ||
                    index === GlobalConfiguration.lengthCheckThree) &&
                    mainData?.length > GlobalConfiguration.lengthCheckZero && (
                      <div
                        style={{
                          zIndex: "var(--z-index-fixed-ui)",
                          width: "var(--width-full)",
                          bottom: "var(--bottom-base)",
                        }}
                        className="fixed w-width-full h-pagination-height"
                      >
                        <PaginationComponent
                          handleSelect={() => {}}
                          selectedValue={
                            PaginationConfiguration.paginationSmall
                          }
                          data={[]}
                          pageSize={PaginationConfiguration.paginationSmall}
                          dropdownOptions={
                            PaginationConfiguration.paginationOptions
                          }
                          // handlePagination={handlePagination}
                          currentPage={GlobalConfiguration.lengthCheckOne}
                          setIsOpen={() => {}}
                        />
                      </div>
                    )}

                  <div className="w-full top-top-base bg-primary-bg pt-padding-md  px-padding-sm lg::px-padding-base">
                    <div className="h-fit lg:mx-auto max-w-tab-width-normal flex flex-col lg:flex-row gap-x-gap-md justify-between bg-primary-bg w-full">
                      <div className="no-scrollbar overflow-x-auto">
                        <SwitcherTabs
                          tabs={[
                            {
                              label: "Details",
                              key: "Details",
                              handler: () => {
                                setIndex(GlobalConfiguration.lengthCheckZero);
                                setselectCardBank(false);
                                setselectCardLive(false);
                              },
                            },
                            {
                              label: "Labels",
                              key: "Labels",
                              handler: () => {
                                setIndex(GlobalConfiguration.lengthCheckOne);
                                setselectCardBank(false);
                                setselectCardLive(false);
                              },
                            },
                            {
                              label: `Consolidated bank statement (${mainData?.length || 0}) `,
                              key: "Consolidated bank statement",
                              handler: () => {
                                setIndex(GlobalConfiguration.lengthCheckTwo);
                                setselectCardLive(false);
                                setConsolidatedLive([]);
                              },
                            },
                            {
                              label: `Consolidated live statement (${mainData?.length || 0}) `,
                              key: "Consolidated live statement",
                              handler: () => {
                                setIndex(GlobalConfiguration.lengthCheckThree);
                                setselectCardBank(false);
                                setConsolidatedBank([]);
                              },
                            },
                          ]}
                          swicherTabBgColor={"var(--primary-card)"}
                          setIndex={setIndex}
                          initialActiveTab={
                            index === GlobalConfiguration.lengthCheckZero
                              ? "Details"
                              : index === GlobalConfiguration.lengthCheckOne
                                ? "Labels"
                                : index === GlobalConfiguration.lengthCheckTwo
                                  ? "Consolidated bank statement"
                                  : index ===
                                      GlobalConfiguration.lengthCheckThree
                                    ? "Consolidated live statement"
                                    : ""
                          }
                        />
                      </div>
                      <div
                        className={` mt-margin-md lg:mt-margin-base ${index === GlobalConfiguration.lengthCheckTwo && mainData?.length > GlobalConfiguration.lengthCheckZero ? "block" : "hidden"}`}
                      >
                        <PrimaryRightIconFill
                          btnText={selectCardBank ? "Cancel" : "Bulk unmatch"}
                          enabledBgColor="var(--primary-nav-act)"
                          isDisabled={false}
                          handleFunction={() => {
                            setselectCardBank(!selectCardBank);
                            if (selectCardBank) {
                              setConsolidatedBank([]);
                            }
                          }}
                          iconToBeAlign="right"
                          enabledTextColor={"var(--text-primary)"}
                          icon={ICONS.UNMATCHED_WITH_CIRCLE}
                          fullWidthRequired={false}
                          hoverOption="white"
                        />
                      </div>
                      <div
                        className={`mt-margin-md lg:mt-margin-base ${index === GlobalConfiguration.lengthCheckThree && mainData?.length > GlobalConfiguration.lengthCheckZero ? "block" : "hidden"}`}
                      >
                        <PrimaryRightIconFill
                          btnText={selectCardLive ? "Cancel" : "Bulk unmatch"}
                          enabledBgColor="var(--primary-nav-act)"
                          isDisabled={false}
                          handleFunction={() => {
                            setselectCardLive(!selectCardLive);
                            if (selectCardBank) {
                              setConsolidatedLive([]);
                            }
                          }}
                          iconToBeAlign="right"
                          enabledTextColor={"var(--text-primary)"}
                          icon={ICONS.UNMATCHED_WITH_CIRCLE}
                          fullWidthRequired={false}
                          hoverOption="white"
                        />
                      </div>
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      <div
                        className={`max-w-tab-width-normal mx-auto no-scrollbar`}
                      >
                        {true &&
                          (() => {
                            let originItemList = [
                              {
                                content:
                                  remitterAccountDetailsData?.created_by_name
                                    ? accountNameStandardised(
                                        remitterAccountDetailsData?.created_by_name,
                                      )
                                    : "Not given",
                                heading: "Created by",
                                type: "text",
                              },
                              {
                                content: remitterAccountDetailsData?.created_on
                                  ? formatDateViewAll(
                                      remitterAccountDetailsData?.created_on,
                                      true,
                                      true,
                                    )
                                  : "Not given",
                                heading: "Created on",
                                type: "text",
                              },
                              {
                                content: "Not available",
                                heading: "Account origin",
                                type: "text",
                              },
                              ...(remitterAccountDetailsData?.approval_status ===
                              "approved"
                                ? [
                                    {
                                      content:
                                        remitterAccountDetailsData?.approved_by_name ||
                                        "Not given",
                                      heading: "Approved by",
                                      type: "text",
                                    },
                                    {
                                      content:
                                        remitterAccountDetailsData?.approved_on
                                          ? formatDateViewAll(
                                              remitterAccountDetailsData?.approved_on,
                                              true,
                                              true,
                                            )
                                          : "Not given",
                                      heading: "Approved on",
                                      type: "text",
                                    },
                                  ]
                                : []),

                              // ✅ REJECTED
                              ...(remitterAccountDetailsData?.approval_status ===
                              "rejected"
                                ? [
                                    {
                                      content:
                                        remitterAccountDetailsData?.rejected_by_name ||
                                        "Not given",
                                      heading: "Rejected by",
                                      type: "text",
                                    },
                                    {
                                      content:
                                        remitterAccountDetailsData?.rejected_on
                                          ? formatDateViewAll(
                                              remitterAccountDetailsData?.rejected_on,
                                              true,
                                              true,
                                            )
                                          : "Not given",
                                      heading: "Rejected on",
                                      type: "text",
                                    },
                                    {
                                      content:
                                        remitterAccountDetailsData?.rejection_reason ||
                                        "Not given",
                                      heading: "Rejected reason",
                                      type: "text",
                                    },
                                  ]
                                : []),

                              // ✅ ARCHIVED
                              ...(remitterAccountDetailsData?.approval_status ===
                              "archived"
                                ? [
                                    {
                                      content:
                                        remitterAccountDetailsData?.archived_by_name ||
                                        "Not given",
                                      heading: "Archived by",
                                      type: "text",
                                    },
                                    {
                                      content:
                                        remitterAccountDetailsData?.archived_on
                                          ? formatDateViewAll(
                                              remitterAccountDetailsData?.archived_on,
                                              true,
                                              true,
                                            )
                                          : "Not given",
                                      heading: "Archived on",
                                      type: "text",
                                    },
                                  ]
                                : []),
                            ];

                            let supportItemList = [
                              {
                                content: remitterAccountDetailsData?.id
                                  ? remitterAccountDetailsData?.id
                                  : "Not given",
                                heading: "Account ID",
                                type: "text",
                              },
                            ];

                            return (
                              <div
                                className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                                  false
                                    ? "justify-between gap-gap-md"
                                    : "gap-gap-md lg:gap-gap-md"
                                }`}
                              >
                                <CommonDetailCard
                                  cardTitle={TEXT?.ORIGIN_DETAILS}
                                  variant="third"
                                  numCols={GlobalConfiguration?.lengthCheckOne}
                                  entries={originItemList}
                                />

                                <CommonDetailCard
                                  cardTitle={TEXT?.SUPPORT_INFORMATION}
                                  numCols={GlobalConfiguration?.lengthCheckOne}
                                  variant="third"
                                  entries={supportItemList}
                                />
                              </div>
                            );
                          })()}
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <div
                        style={{
                          scrollbarWidth: "none",
                        }}
                        className="mt-margin-md mb-margin-md lg:mx-auto overflow-x-hidden max-w-tab-width-normal"
                      >
                        <CommonContainerCard
                          header="Labels"
                          iconIsDisabled={true}
                          subheader={TEXT?.LABELS_STATS_USAGE_NOTE}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            if (popup) {
                              actionRestricted();
                            } else {
                              CommonToast({
                                text: "Feature coming soon",
                                icon: ICONS?.INFO,
                                variant: "var(--coming-soon)",
                                buttonNeeded: false,
                              });
                            }
                          }}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                            {Array.isArray(labelDetails) &&
                            labelDetails?.length >
                              GlobalConfiguration.lengthCheckZero ? (
                              <>
                                {labelDetails?.map((item, index) => (
                                  <Chips
                                    key={index}
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      return;
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                Not assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration.lengthCheckTwo && (
                    <>
                      <div className={animationClass}>
                        {mainData?.length >
                        GlobalConfiguration.lengthCheckZero ? (
                          <div className="pt-padding-md">
                            <div
                              ref={bankBarRef}
                              className={`lg:mx-auto absolute w-width-full flex justify-center z-z-index-content transition-all duration-animation-fast ease-in-out ${selectCardBank ? "opacity-base-opacity" : "opacity-light-opacity"}`}
                            >
                              <div className="flex bg-primary-nav px-padding-md flex-wrap justify-between rounded-border-radius-md max-w-tab-width-normal w-width-full mx-margin-sm">
                                <div className="text-font-xs text-text-primary pr-padding-md Qsmd:pr-padding-base my-margin-sm flex items-center">
                                  {`Transactions selected : ${consolidatedBank.length} `}
                                </div>
                                <div className="flex gap-gap-sm">
                                  <div className="my-margin-sm">
                                    <SecondaryRightIconSmallButton
                                      btnText="Select all"
                                      btnType="button"
                                      handleFunction={() => {
                                        const isAllSelected =
                                          consolidatedBank?.length ===
                                          mainData?.length;

                                        if (isAllSelected) {
                                          // Unselect all
                                          setConsolidatedBank([]);
                                        } else {
                                          // Select all
                                          const allIds = mainData?.map(
                                            (item) => item?.txn_id,
                                          );
                                          setConsolidatedBank(allIds);
                                        }
                                      }}
                                      isDisabled={false}
                                      enabledTextColor="var(--text-primary)"
                                      enabledBgColor={
                                        consolidatedBank?.length ===
                                        mainData?.length
                                          ? "var(--positive-bg)"
                                          : "var(--primary-nav-act)"
                                      }
                                      hoverOption={
                                        consolidatedBank?.length ===
                                        mainData?.length
                                          ? "black"
                                          : "white"
                                      }
                                      icon={
                                        consolidatedBank?.length ===
                                        mainData?.length
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WHITE_OUTLINE
                                      }
                                    />
                                  </div>
                                  <div className="my-margin-sm">
                                    <PrimaryButton
                                      enabledBgColor={
                                        consolidatedBank?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? "var(--text-primary)"
                                          : "var(--text-disabled)"
                                      }
                                      inActiveVariantNeeded={
                                        consolidatedLive?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? false
                                          : true
                                      }
                                      isDisabled={
                                        consolidatedBank?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? false
                                          : true
                                      }
                                      btnText="Unmatch"
                                      enabledTextColor={
                                        consolidatedBank?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? "var(--primary_bg)"
                                          : "var(--text-primary)"
                                      }
                                      handleFunction={() => {
                                        if (
                                          consolidatedBank?.length >
                                          GlobalConfiguration.lengthCheckZero
                                        ) {
                                          setViewstatementOpenPop(true);
                                          // CommonToast({
                                          //   text: "Feature coming soon",
                                          //   icon: ICONS?.INFO,
                                          //   variant: "var(--coming-soon)",
                                          //   buttonNeeded: false,
                                          // });
                                        }
                                      }}
                                      hoverOption={
                                        consolidatedBank?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? "black"
                                          : "white"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              ref={scrollContainerRef}
                              className="bg-primary-bg relative z-z-index-header transition-all duration-animation-fast ease-in-out overflow-y-auto flex-1 h-full flex standard-card-alignment !pt-padding-base gap-x-gap-sm gap-y-gap-md"
                              style={{
                                marginTop: selectCardBank
                                  ? `${bankBarHeight}px`
                                  : undefined,
                              }}
                            >
                              {mainData?.map((transactions) => {
                                return (
                                  <CardContainer
                                    key={transactions?.txn_id}
                                    isSelected={
                                      selectCardBank
                                        ? consolidatedBank?.includes(
                                            transactions.txn_id,
                                          )
                                        : selectedCardId === transactions.txn_id
                                    }
                                    onClickHandler={() => {
                                      if (selectCardBank) {
                                        handleCardClick(transactions);
                                      } else {
                                        CommonToast({
                                          text: "Feature coming soon",
                                          icon: ICONS?.INFO,
                                          variant: "var(--coming-soon)",
                                          buttonNeeded: false,
                                        });
                                      }
                                    }}
                                  >
                                    <card-body>
                                      <TextWithIcon
                                        type={"Amount"}
                                        fontWeight={"semibold"}
                                        text={transactions?.amount}
                                        subText={"Amount"}
                                        textColor={"var(--settled)"}
                                        iconComponentArray={[
                                          ...(true
                                            ? [
                                                {
                                                  icon: consolidatedBank.includes(
                                                    transactions.txn_id,
                                                  )
                                                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                                    : selectCardBank
                                                      ? ICONS?.NOTSELECTED_WITH_GREY_CIRCLE
                                                      : ICONS.UNMATCH,
                                                  isDisabled: false,
                                                },
                                              ]
                                            : []),
                                        ]}
                                      />

                                      <TextWithIcon
                                        text={transactions?.beneficiary_account_name
                                          ?.toLowerCase()
                                          ?.split(" ")
                                          ?.map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1),
                                          )
                                          ?.join(" ")}
                                        type={"Text"}
                                        subText={"Name"}
                                        fontWeight={"normal"}
                                        textColor={"var(--text-primary)"}
                                      />

                                      <TextWithBank
                                        text={"Not given"}
                                        subText={"Transaction date"}
                                        type={"Text"}
                                        ifscCode={
                                          transactions?.beneficiary_account_ifsc_code
                                        }
                                      />
                                    </card-body>
                                  </CardContainer>
                                );
                              })}
                            </div>
                            <div className="h-breadcrumb-height block"></div>
                          </div>
                        ) : (
                          <>
                            <div className="w-full max-w-tab-width-normal mx-auto my-margin-md">
                              <CommonContainerCard
                                header="No transactions have been matched yet."
                                iconIsDisabled={true}
                                handleFunction={(e) => {
                                  CommonToast({
                                    text: "Feature coming soon",
                                    icon: ICONS?.INFO,
                                    variant: "var(--coming-soon)",
                                    buttonNeeded: false,
                                  });
                                }}
                              >
                                <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                                  <Chips
                                    key={index}
                                    isDisabled={isArchivedAccount}
                                    txtChip={"Match transactions"}
                                    enabledBgColor="var(--primary-nav)"
                                    hoverOption={"white"}
                                    hoverOptionBtn="white"
                                    handleFunctionBtn={() => {
                                      CommonToast({
                                        text: "Feature coming soon",
                                        icon: ICONS?.INFO,
                                        variant: "var(--coming-soon)",
                                        buttonNeeded: false,
                                      });
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                </div>
                              </CommonContainerCard>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {index === GlobalConfiguration.lengthCheckThree && (
                    <>
                      <div className={animationClass}>
                        {mainData?.length >
                        GlobalConfiguration.lengthCheckZero ? (
                          <div className="pt-padding-md">
                            <div
                              ref={liveBarRef}
                              className={`lg:mx-auto absolute w-width-full flex justify-center z-z-index-content ${selectCardLive ? "opacity-base-opacity" : "opacity-light-opacity"}  transition-all duration-animation-fast ease-in-out`}
                            >
                              <div className="flex bg-primary-nav px-padding-md flex-wrap justify-between rounded-border-radius-md max-w-tab-width-normal w-width-full mx-margin-sm">
                                <div className="text-font-xs text-text-primary pr-padding-md lg:pr-padding-base my-margin-sm flex items-center">
                                  {`Transactions selected : ${consolidatedLive?.length} `}
                                </div>
                                <div className="flex gap-gap-sm">
                                  <div className="my-margin-sm">
                                    <SecondaryRightIconSmallButton
                                      btnText="Select all"
                                      btnType="button"
                                      handleFunction={() => {
                                        const isAllSelected =
                                          consolidatedLive?.length ===
                                          mainData?.length;

                                        if (isAllSelected) {
                                          // Unselect all
                                          setConsolidatedLive([]);
                                        } else {
                                          // Select all
                                          const allIds = mainData?.map(
                                            (item) => item.txn_id,
                                          );
                                          setConsolidatedLive(allIds);
                                        }
                                      }}
                                      isDisabled={false}
                                      enabledTextColor="var(--text-primary)"
                                      enabledBgColor={
                                        consolidatedLive?.length ===
                                        mainData?.length
                                          ? "var(--positive-bg)"
                                          : "var(--primary-nav-act)"
                                      }
                                      hoverOption={
                                        consolidatedLive?.length ===
                                        mainData?.length
                                          ? "black"
                                          : "white"
                                      }
                                      icon={
                                        consolidatedLive?.length ===
                                        mainData?.length
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WHITE_OUTLINE
                                      }
                                    />
                                  </div>
                                  <div className="my-margin-sm">
                                    <PrimaryButton
                                      enabledBgColor={
                                        consolidatedLive?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? "var(--text-primary)"
                                          : "var(--text-disabled)"
                                      }
                                      inActiveVariantNeeded={
                                        consolidatedLive?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? false
                                          : true
                                      }
                                      btnText="Unmatch"
                                      isDisabled={
                                        consolidatedLive?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? false
                                          : true
                                      }
                                      enabledTextColor={
                                        consolidatedLive?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? "var(--primary_bg)"
                                          : "var(--text-primary)"
                                      }
                                      handleFunction={() => {
                                        if (
                                          consolidatedLive?.length >
                                          GlobalConfiguration.lengthCheckZero
                                        ) {
                                          setViewstatementOpenPop(true);
                                          // CommonToast({
                                          //   text: "Feature coming soon",
                                          //   icon: ICONS?.INFO,
                                          //   variant: "var(--coming-soon)",
                                          //   buttonNeeded: false,
                                          // });
                                        }
                                      }}
                                      hoverOption={
                                        consolidatedLive?.length >
                                        GlobalConfiguration.lengthCheckZero
                                          ? "black"
                                          : "white"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              ref={scrollContainerRef}
                              className={`bg-primary-bg relative z-z-index-header transition-all duration-animation-fast ease-in-out overflow-y-auto flex-1 flex standard-card-alignment !pt-padding-base h-full gap-x-gap-sm gap-y-gap-md`}
                              style={
                                selectCardLive
                                  ? { marginTop: `${liveBarHeight}px` }
                                  : undefined
                              }
                            >
                              {mainData?.map((transactions) => {
                                return (
                                  <>
                                    <CardContainer
                                      key={transactions?.txn_id}
                                      isSelected={
                                        selectCardLive
                                          ? consolidatedLive?.includes(
                                              transactions.txn_id,
                                            )
                                          : selectedLiveCardId ===
                                            transactions.txn_id
                                      }
                                      onClickHandler={() => {
                                        if (selectCardLive) {
                                          handleLiveCardClick(transactions);
                                        } else {
                                          CommonToast({
                                            text: "Feature coming soon",
                                            icon: ICONS?.INFO,
                                            variant: "var(--coming-soon)",
                                            buttonNeeded: false,
                                          });
                                        }
                                      }}
                                    >
                                      <card-body>
                                        <TextWithIcon
                                          type={"Amount"}
                                          fontWeight={"semibold"}
                                          text={transactions?.amount}
                                          subText={"Amount"}
                                          textColor={"var(--settled)"}
                                          iconComponentArray={[
                                            ...(true
                                              ? [
                                                  {
                                                    icon: consolidatedLive?.includes(
                                                      transactions.txn_id,
                                                    )
                                                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                                      : selectCardLive
                                                        ? ICONS?.NOTSELECTED_WITH_GREY_CIRCLE
                                                        : ICONS.UNMATCH,
                                                    isDisabled: false,
                                                  },
                                                ]
                                              : []),
                                          ]}
                                        />

                                        <TextWithIcon
                                          text={transactions.beneficiary_account_name
                                            .toLowerCase()
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1),
                                            )
                                            .join(" ")}
                                          type={"Text"}
                                          subText={"Name"}
                                          fontWeight={"normal"}
                                          textColor={"var(--text-primary)"}
                                        />
                                        <TextWithBank
                                          text={"Not given"}
                                          subText={"Transaction date"}
                                          type={"Text"}
                                          // src={categoryMapper(
                                          //   transactions.category,
                                          // )}
                                          ifscCode={
                                            transactions.beneficiary_account_ifsc_code
                                          }
                                        />
                                      </card-body>
                                    </CardContainer>
                                  </>
                                );
                              })}
                            </div>
                            <div className="h-breadcrumb-height block"></div>
                          </div>
                        ) : (
                          <>
                            <div className="w-full max-w-tab-width-normal mx-auto my-margin-md">
                              <CommonContainerCard
                                header="No transactions have been matched yet."
                                iconIsDisabled={true}
                                handleFunction={(e) => {
                                  CommonToast({
                                    text: "Feature coming soon",
                                    icon: ICONS?.INFO,
                                    variant: "var(--coming-soon)",
                                    buttonNeeded: false,
                                  });
                                }}
                              >
                                <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                                  <Chips
                                    key={index}
                                    isDisabled={isArchivedAccount}
                                    txtChip={"Match transactions"}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    hoverOption="white"
                                    hoverOptionBtn="white"
                                    handleFunctionBtn={() => {
                                      CommonToast({
                                        text: "Feature coming soon",
                                        icon: ICONS?.INFO,
                                        variant: "var(--coming-soon)",
                                        buttonNeeded: false,
                                      });
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                </div>
                              </CommonContainerCard>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default RemitterAccountDetails;
